type GenricClockProps = {
  color?: string;
  size?: number | string; // Accepts values like 36 or "2rem"
};

const defaultColor = '#0E6F63';
const defaultSize = 36;

const GenericClock: React.FC<GenricClockProps> = ({
  color = defaultColor,
  size = defaultSize,
}) => (
  <svg
    viewBox="0 0 36 36"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill={color}
  >
    <path d="M18,0C8.1,0,0,8.1,0,18s8.1,18,18,18s18-8.1,18-18S27.9,0,18,0z M18,32.4c-8,0-14.4-6.5-14.4-14.4
      S10,3.6,18,3.6S32.4,10,32.4,18S26,32.4,18,32.4z" />
    <path d="M18.9,9h-1.8v10.3l9.1,5.4l0.9-1.5l-8.2-4.9V9z" />
  </svg>
);

export default GenericClock;
